module.exports = __webpack_public_path__ + "static/img/p_2_10.cd69a4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p_2_10.jpg
// module id = HOPa
// module chunks = 1